import styled from "styled-components";

export const SpaceBetween = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
